import React from 'react';

import Button from 'fuse-ui/components/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import PropTypes from 'prop-types';
import Typography from 'fuse-ui/components/Typography';
import { withStyles } from '@material-ui/core/styles';
import { CANVAS_CARD_HEADER_HEIGHT } from '../constants/ui-options';
import LoadingSpinner from '../../common/components/loading-spinner';

//Note this will be the full width of the parent container. If you do not specify margins or padding you will not see the border
const styles = theme => ( {
    cardContent: {
        height: '100%',
    },
    cardContentNoContentPadding: {
        height: '100%',
        padding: `${theme.spacing.unit * 2}px 0`,
    },
    defaultMessage: {
        alignItems: 'center',
        display: 'flex',
        height: `calc(100% - ${CANVAS_CARD_HEADER_HEIGHT}px)`,
        justifyContent: 'center',
    },
    fullWidth: {
        border: '2px solid green',
        padding: 0,
    },
    header: {
        alignItems: 'center',
        display: 'flex',
        marginBottom: theme.spacing.unit * 3,
    },
    headerNoContentPadding: {
        display: 'flex',
        margin: `0 ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    headingButton: {
        marginRight: `-${theme.spacing.unit * 2}px`,
    },
    headingButtonContainer: {
        marginLeft: 'auto',
    },
} );

const CanvasCard = (
    {
        header: { title = '', buttonText, buttonAction = () => {} },
        children,
        classes,
        defaultMessageComponent,
        automationId,
        isLoading,
        noContentPadding
    } ) => {
    const content = children ?  children : <div className={classes.defaultMessage}>{ defaultMessageComponent }</div>;

    return (
        <Card className={classes.card} data-automation-id={automationId}>
            <CardContent className={noContentPadding ? classes.cardContentNoContentPadding : classes.cardContent}>
                <div className={noContentPadding ? classes.headerNoContentPadding : classes.header}>
                    <Typography align="center" variant="h6" gutterBottom={false} >{ title }</Typography>

                    { buttonText &&
                        ( <div className={classes.headingButtonContainer}>
                            <Button variant="text" onClick={buttonAction} className={ classes.headingButton } data-automation-id={`${automationId}-button`}>
                                { buttonText }
                            </Button>
                        </div> )
                    }
                </div>

                {
                    isLoading ? (
                        <div className={classes.defaultMessage}>
                            <LoadingSpinner />
                        </div>
                    ) : content
                }
            </CardContent>
        </Card>
    );
};

CanvasCard.propTypes = {
    automationId: PropTypes.string.isRequired,
    children: PropTypes.node,
    classes: PropTypes.object,
    defaultMessageComponent: PropTypes.node,
    header: PropTypes.shape( {
        buttonAction: PropTypes.func,
        buttonText: PropTypes.string,
        title: PropTypes.string,
    } ),
    isLoading: PropTypes.bool,
    noContentPadding: PropTypes.bool,
};

CanvasCard.defaultProps = {
    automationId: 'canvas-card',
    defaultMessageComponent: <Typography>Data Is Unavailable</Typography>,
    header: {},
};

export default withStyles( styles )( CanvasCard );
